import { render, staticRenderFns } from "./FindRecruiter.vue?vue&type=template&id=2ff2eed7&"
import script from "./FindRecruiter.vue?vue&type=script&lang=js&"
export * from "./FindRecruiter.vue?vue&type=script&lang=js&"
import style0 from "./FindRecruiter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports